import { FC, SVGProps } from 'react';

export const sizes = {
  xs: 36,
  s: 48,
  m: 56,
  l: 64,
  xl: 128,
};

export type SizeAlias = keyof typeof sizes;
type Size = SizeAlias | number;

export const computeSize = (size: Size): number => {
  if (typeof size === 'number') {
    return size;
  }

  return sizes[size];
};

export interface IconBaseProps extends SVGProps<SVGSVGElement> {
  id?: string;
  size?: Size;
  inverse?: boolean;
}

export const IconBase: FC<IconBaseProps> = props => {
  const { children, size, inverse = false, ...rest } = props;

  const computedSize = size === undefined ? '1em' : computeSize(size);
  const { color = inverse ? '#fff' : '#000', ...restStyle } = rest.style ?? {};

  return (
    <svg
      style={{ color, ...restStyle }}
      width={computedSize}
      height={computedSize}
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {children}
    </svg>
  );
};

type IconComponent = FC;
type Components = Partial<Record<SizeAlias, IconComponent>> & {
  otherwise: IconComponent;
};

export const matchSize = (
  size: Size | undefined,
  components: Components,
): FC<IconBaseProps> => {
  if (size === undefined || typeof size === 'number') {
    return components.otherwise;
  }

  const matched = components[size];

  if (matched === undefined) {
    return components.otherwise;
  }

  return matched;
};
